var csrf_token,
  contactFormChecker = [],
  formCheckerObj = {},
  formCheckerElm, checkEmailValidation = false;

window.addEventListener("load", function () {
  // load recaptcha JS after page load
  document.addEventListener("click", loadRecaptchaForForm);

  function loadRecaptchaForForm() {
    var captchaFieldJS = document.getElementById("recaptcha-js");
    if (!captchaFieldJS && typeof grecaptcha === "undefined") {
      var scriptElm = document.createElement("script");
      scriptElm.setAttribute("id", "recaptcha-js");
      scriptElm.setAttribute("type", "text/javascript");
      scriptElm.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?ver=1.0"
      );
      scriptElm.setAttribute("defer", "defer");
      document.body.appendChild(scriptElm);

      var intCap = 0, handleCapTimer = setInterval(function() {
        if (intCap > 10 || (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render !== 'undefined')) {
          var contentContactForm = document.querySelectorAll(".contact-form");
          for (var i = 0; i < contentContactForm.length; i++) {
            var captchaField = contentContactForm[i].querySelector('.recaptcha-wrapper');
            if (captchaField) {
              CSFMultiFormScope.renderCheckBoxCaptchaField(captchaField);
            }
          }
          clearInterval(handleCapTimer);
        }
        intCap += 1;
      }, 250);
    }
  }
});

//Contact Form
var contentContactForm = document.querySelectorAll(".contact-form");
for (var i = 0; i < contentContactForm.length; i++) {
  formCheckerObj = {};
  formCheckerObj.formObj = contentContactForm[i];
  formCheckerObj.index = i;
  formCheckerObj.uniqueID = bsLib.uniqueID();

  formCheckerObj.nameField =
    formCheckerObj.formObj.querySelector('[name="name"]');
  formCheckerObj.emailField =
    formCheckerObj.formObj.querySelector('[name="email"]');
  formCheckerObj.queryType = formCheckerObj.formObj.querySelector(
    '[name="query_type"]'
  );
  formCheckerObj.messageField =
    formCheckerObj.formObj.querySelector('[name="message"]');
  formCheckerObj.companyField =
    formCheckerObj.formObj.querySelector('[name="company"]');
  formCheckerObj.requestType = formCheckerObj.formObj.querySelector(
    '[name="request_type"]'
  );
  formCheckerObj.utf8 = formCheckerObj.formObj.querySelector('[name="utf8"]');
  formCheckerObj.formsubmit =formCheckerObj.formObj.querySelector('[name="commit"]');
  formCheckerObj.captchaField =formCheckerObj.formObj.querySelector('.recaptcha-wrapper');
  formCheckerObj.authenticityToken = formCheckerObj.formObj.querySelector(
    '[name="authenticity_token"]'
  );
  formCheckerObj.sendEmail = formCheckerObj.formObj.querySelector(
    '[name="send_email"]'
  );
  formCheckerObj.workEmail = formCheckerObj.formObj.querySelector(
    '[name="work_email"]'
  );
  formCheckerObj.utmCampaign = formCheckerObj.formObj.querySelector(
    '[name="utm_campaign"]'
  );
  formCheckerObj.utmAdgroup = formCheckerObj.formObj.querySelector(
    '[name="utm_adgroup"]'
  );
  formCheckerObj.gclid = formCheckerObj.formObj.querySelector('[name="gclid"]');
  formCheckerObj.utmSource = formCheckerObj.formObj.querySelector(
    '[name="utm_source"]'
  );

  formCheckerObj.InteractedwithCSFBool = true;

  //captcha
  formCheckerObj.captcha = formCheckerObj.formObj.querySelector(
    '[name="utm_source"]'
  );

  //Set Query Params value
  formCheckerObj.utmCampaign.value = bsLib.getParameterByName("utm_campaign");
  formCheckerObj.utmAdgroup.value = bsLib.getParameterByName("utm_adgroup");
  formCheckerObj.gclid.value = bsLib.getParameterByName("gclid");
  formCheckerObj.utmSource.value = bsLib.getParameterByName("utm_source");

  contactFormChecker[i] = formCheckerObj;
}

var CSFMultiFormScope = (function (csrfToken, contactFormChecker) {
  return {
    init: init,
    setScope: setScope,
    resetForm: resetForm,
    validateFields: _validateFields,
    setCsrfToken: setCsrfToken,
    renderCheckBoxCaptchaField: renderCheckBoxCaptchaField
  };

  var formCheckerObj = {},
    uniqueID,
    index,
    captchaWidgetId;

  function setScope(scope) {
    formCheckerObj = {};
    index = getFormIndex(scope);
    formCheckerObj = contactFormChecker[index];
    uniqueID = formCheckerObj.uniqueID;
  }

  function renderCheckBoxCaptchaField(captchaField) {
    //remove captcha
    var captchaWidget;
  
    //recaptcha render from JS
    if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render !== 'undefined' && captchaField.childNodes.length === 0) {
      captchaWidget = grecaptcha.render(captchaField, {
        'sitekey' : captchaField.dataset.sitekey,
        'theme' : 'light',
        'badge': 'bottomright',
        'size': 'invisible',
        'callback' : function () {
          return init();
        }
      });
  
      captchaField.dataset.gWidgetId = captchaWidget;
    } else if (typeof grecaptcha !== "undefined" && captchaField.childNodes.length >= 0) {
      captchaWidget = captchaField.dataset.gWidgetId;
    }
    return captchaWidget;
  }

  function init() {
    return new Promise(function (resolve, reject) {
    formCheckerObj.formsubmit.setAttribute("disabled", "disabled");
    formCheckerObj.formsubmit.value = formCheckerObj.formsubmit.dataset.btndisabled;

    captchaWidgetId = renderCheckBoxCaptchaField(formCheckerObj.captchaField);
    var grecaptchaResponse = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse(captchaWidgetId) : '';
    if (grecaptchaResponse.length === 0) {
      new bsAlert({
        alertType: "error",
        timeout: 5000,
        text: Messages.salesAndSupportPage.noRecaptcha
      });

      reject();
    }

    // xhr request for sending form data
    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/contact",
      //Form Data
      {
        name: formCheckerObj.nameField.value,
        email: formCheckerObj.emailField.value,
        query_type: formCheckerObj.queryType.value,
        message: ((formCheckerObj.messageField.dataset.message != "" && typeof formCheckerObj.messageField.dataset.message !== "undefined") ? formCheckerObj.messageField.dataset.message: "") + formCheckerObj.messageField.value,
        company: formCheckerObj.companyField.value,
        send_email: formCheckerObj.sendEmail.value,
        authenticity_token: csrf_token,
        utf8: formCheckerObj.utf8.value,
        request_type: formCheckerObj.requestType.value,
        utm_campaign: formCheckerObj.utmCampaign.value,
        utm_adgroup: formCheckerObj.utmAdgroup.value,
        gclid: formCheckerObj.gclid.value,
        utm_source: formCheckerObj.utmSource.value,
        page_url: window.location.href,
        cta_ref: bsLib.getParameterByName("ref"),
        "g-recaptcha-response": grecaptchaResponse,
        ga_cid: bsLib.GAClientID(),
        source: "wp_form",
        utm_campaigncode: document.querySelector('[name="sfdc_utm_campaigncode"]').value.trim(),
        additional_notes: document.querySelector('[name="additional_notes"]').value.trim(),
        primary_product: document.querySelector('[name="primary_product"]').value.trim(),
        secondary_product: document.querySelector('[name="secondary_product"]').value.trim(),
        previous_page_url: (document.referrer !== '') ? document.referrer : 'organic',
        lead_source: "Contact Sales Form",
        check_email_domain: true,
      },
      false,
      //Form Header
      {
        "X-CSRF-Token": csrfToken,
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8", // Setting content type.
      },
      //Form Success
      function (data) {
        var dataRequest = bsLib.JSONParse(data.response);
        if (dataRequest.success === true) {
          var modalContainer = document.querySelector(".thank-you-modal"),
            modal = new tingle.modal({
              cssClass: ["small-modal"],
              onClose: function () {
                modal.destroy();
              },
            });
          modal.setContent(modalContainer.innerHTML);
          modal.open();

          _afterSubmitSuccess();
          _logFormSubmit("FormSubmitSuccess");

          resolve();
        } else {
          if (dataRequest.field == "business_email") {
            formCheckerObj.emailField.classList.add("error-border");
            if (
              formCheckerObj.emailField.parentNode.getElementsByClassName(
                "error-message"
              ).length === 0
            ) {
              var parentElement = formCheckerObj.emailField.parentElement;
              if (parentElement && parentElement.querySelector(".email-notify-msg")) {
                  parentElement.querySelector(".email-notify-msg").classList.add("hide");
              }
              formCheckerObj.emailField.insertAdjacentHTML(
                "afterend",
                '<span class="error-message" id= "email-error">' +
                  dataRequest.message +
                  "</span>"
              );
            }
            if (contactFormElemt.formsubmit) {
              contactFormElemt.formsubmit.removeAttribute("disabled");
              contactFormElemt.formsubmit.value = contactFormElemt.formsubmit.dataset.valueText;
            }
            grecaptcha.reset();
            checkEmailValidation = true;
          }
          _logFormSubmit("FormSubmitError");
          reject();
        }
      },
      //Form Error
      function () {
        _logFormSubmit("FormSubmitError");
        reject();
      }
    );
    });
  }

  function setCsrfToken() {
    // XHR request for user token
    if (!csrf_token) {
      // XHR request for user token
      bsLib.ajax(
        "GET",
        bsLib.railsHost() + "/user/token.json",
        {},
        false,
        {},
        // Success message for user token.
        function (data) {
          var dataRequest = bsLib.JSONParse(data.response);
          csrfToken = dataRequest.csrf_token;
          csrf_token = csrfToken;
        },
        // Custom Error message for user token.
        function () {
          return Messages.salesAndSupportPage.invalidUserToken;
        }
      );
    } else if (!csrfToken) {
      csrfToken = csrf_token;
    }
  }

  function _validateFields() {
    captchaWidgetId = renderCheckBoxCaptchaField(formCheckerObj.captchaField);

    var formValid = true,
      namerError = document.getElementById("name-error" + uniqueID),
      emailError = document.getElementById("email-error" + uniqueID),
      messageError = document.getElementById("message-error" + uniqueID),
      companyError = document.getElementById("company-error" + uniqueID),
      recaptchaError = document.getElementById("recaptcha-error" + uniqueID),
      grecaptchaResponse = typeof grecaptcha !== 'undefined' && grecaptcha.hasOwnProperty("getResponse") ? grecaptcha.getResponse(captchaWidgetId) : '';

    //set csrf token
    setCsrfToken();

    //Remove all errors
    removeAllError();

    if (formCheckerObj.nameField.value.length === 0) {
      formValid = _showError(
        formCheckerObj.nameField,
        namerError,
        "name-error" + uniqueID,
        Messages.salesAndSupportPage.invalidName
      );
    }

    if (formCheckerObj.emailField.value == "") {
      formValid = _showError(
        formCheckerObj.emailField,
        emailError,
        "email-error" + uniqueID,
        Messages.salesAndSupportPage.noemail
      );
    } else if (!bsLib.validEmail(formCheckerObj.emailField.value)) {
      formValid = _showError(
        formCheckerObj.emailField,
        emailError,
        "email-error" + uniqueID,
        Messages.salesAndSupportPage.invalidEmail
      );
    } else if (formCheckerObj.emailField.dataset.notvalid === "1") {
      formValid = _showError(
        formCheckerObj.emailField,
        emailError,
        "email-error" + uniqueID,
        Messages.salesAndSupportPage.invalidEmail
      );
    }

    if (formCheckerObj.messageField.value.length === 0) {
      formValid = _showError(
        formCheckerObj.messageField,
        messageError,
        "message-error" + uniqueID,
        Messages.salesAndSupportPage.invalidMessage
      );
    }

    if (formCheckerObj.companyField.value.length === 0) {
      formValid = _showError(
        formCheckerObj.companyField,
        companyError,
        "company-error" + uniqueID,
        Messages.salesAndSupportPage.noCompanyName
      );
    }

    if (formValid) {
      grecaptcha.execute(captchaWidgetId);
    }

    return formValid;
  }

  function removeAllError() {
    //Remove all error element
    var errorMsg = formCheckerObj.formObj.querySelectorAll(".error-message");
    for (var i = 0; i < errorMsg.length; i++) {
      errorMsg[i].remove();
    }
    //remove error border class
    var errorMsg =
      formCheckerObj.formObj.parentElement.querySelectorAll(".error-border");
    for (var i = 0; i < errorMsg.length; i++) {
      errorMsg[i].classList.remove("error-border");
    }
  }

  //Get form index
  function getFormIndex(formObj) {
    var index;
    for (var i = 0; i < contactFormChecker.length; i++) {
      if (contactFormChecker[i].formObj == formObj) {
        index = contactFormChecker[i].index;
      }
    }

    return index;
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    inlineError.showError(fieldName, fieldError, errorName, errorMessage);

    var getFieldName = fieldName.getAttribute("name");

    if (getFieldName == "email") {
      var emailNotifyMsg = fieldName.parentElement.querySelector(".email-notify-msg");
      if (emailNotifyMsg) {
        emailNotifyMsg.remove();
      }
    }

    //assign custom field name
    if (typeof fieldName.dataset.field !== "undefined") {
      getFieldName = fieldName.dataset.field;
    }

    WebEventTracker.logEvent(EDS.webEvents, "SubmitContactForm", {
      field: getFieldName,
      InvalidInput: true,
      message: errorMessage,
      QueryTypeSubmitted: 'Sales'
    });

    return false;
  }

  function _afterSubmitSuccess() {
    resetForm();
  }

  function resetForm() {
    formCheckerObj.formObj.reset(); //Reset form
    if (
      formCheckerObj.captchaField &&
      typeof grecaptcha !== "undefined" &&
      typeof formCheckerObj.captchaField.dataset.gWidgetId !== "undefined"
    ) {
      grecaptcha.reset(formCheckerObj.captchaField.dataset.gWidgetId); // reset captcha
    }
  }

  function _logFormSubmit(status) {
    var data = {},
      queryType = formCheckerObj.queryType.getAttribute("data-query-text"),
      queryVal = formCheckerObj.queryType.getAttribute("value");

    data.experiment = "false";
    data[status] = true;
    data.QueryTypeSubmitted = queryType ? queryType : "No query type";
    WebEventTracker.logEvent(EDS.webEvents, "SubmitContactForm", data);
    if (typeof ga !== "undefined") {
      ga("browserstack.send", "event", {
        eventCategory: "Contact",
        eventAction: "CtaClick",
        eventLabel: "Submit",
        eventValue: queryVal,
      });
    }
    formCheckerObj.formsubmit.removeAttribute("disabled");
    formCheckerObj.formsubmit.value =formCheckerObj.formsubmit.dataset.valueText;
  }
})(csrf_token, contactFormChecker);

function intereactedWithFormField(formCheckerElm, data) {
  var index;
  for (var k = 0; k < contactFormChecker.length; k++) {
    if (contactFormChecker[k].formObj == formCheckerElm.formObj) {
      index = contactFormChecker[k].index;
    }
  }

  //add interaction for form first interaction
  if (contactFormChecker[index].InteractedwithCSFBool) {
    contactFormChecker[index].InteractedwithCSFBool = false;
    WebEventTracker.logEvent(EDS.webEvents, "InteractedWithSalesForm", data);
  }

  if (formCheckerElm.captchaField) {
    CSFMultiFormScope.renderCheckBoxCaptchaField(formCheckerElm.captchaField)
  }

  var dataEvnName = "InteractedWithSalesForm";
  switch (data.field) {
    case 'name':
      dataEvnName = "CsfInteractedWithNameField";
      break;
    case 'email':
      dataEvnName = "CsfInteractedWithEmailField";
      break;
    case 'company':
      dataEvnName = "CsfInteractedWithCompanyField";
      break;
    case 'message':
      dataEvnName = "CsfInteractedWithMessageField";
      break;
    case 'submit':
      dataEvnName = "SubmitContactForm";
      break;
    default:
  }

  WebEventTracker.logEvent(EDS.webEvents, dataEvnName, data);
}

//Contact Form
for (var j = 0; j < contactFormChecker.length; j++) {
  var contactFormEleMulti = contactFormChecker[j];

  //Interacted with fields
  contactFormEleMulti.nameField.addEventListener("blur", function (event) {
    intereactedWithFormField(contactFormEleMulti, {
      field: "name",
      action: "click",
    });
  });

  contactFormEleMulti.emailField.addEventListener("blur", function (event) {
    var emailUniqueID;
    if (checkEmailValidation ) {
      return;
    }
    // get unique id for email error
    for (var l = 0; l < contactFormChecker.length; l++) {
      if (contactFormChecker[l].formObj == this.closest("form.contact-form")) {
        contactFormElemt = contactFormChecker[l];
        emailUniqueID = contactFormChecker[l].uniqueID;
      }
    }

    intereactedWithFormField(contactFormEleMulti, {
      field: "email",
      action: "click",
    });

    // email blur validation
    if (contactFormElemt.emailField) {
      var validEmail = true,
        that = this,
        submitBtn = contactFormElemt.formsubmit,
        emailError = document.getElementById("email-error" + emailUniqueID);

      //false valid dataset
      that.dataset.notvalid = "0";

      //remove existing error
      if (emailError) {
        emailError.remove();
      }

      // check csrf token value
      if (!csrf_token) {
        CSFMultiFormScope.setCsrfToken();
      }

      var emailNotifyMsg = contactFormElemt.emailField.parentElement.querySelector(".email-notify-msg");
      if (emailNotifyMsg) {
        emailNotifyMsg.remove();
      }

      if (that.value.length == 0 || !bsLib.validEmail(that.value)) {
        validEmail = false;

        that.classList.add("error-border");
        that.insertAdjacentHTML(
          "afterend",
          '<span class="error-message" id= "email-error' +
            emailUniqueID +
            '">' +
            (that.value.length == 0
              ? Messages.salesAndSupportPage.noemail
              : Messages.salesAndSupportPage.invalidEmail) +
            "</span>"
        );
      } else {
        that.classList.remove("error-border");
      }

      if (validEmail) {
        //Disable submit button
        if (submitBtn) {
          submitBtn.setAttribute("disabled", "disabled");
          submitBtn.value = Messages.salesAndSupportPage.validateText;
        }

        var workEmailParam = "", 
          emailErrorMsg = Messages.salesAndSupportPage.invalidEmail;
        if (contactFormElemt.workEmail == "true") {
          workEmailParam = "&source=paid_ads";
          emailErrorMsg = Messages.salesAndSupportPage.invalidWorkEmail;
        }

        bsLib.ajax(
          "GET",
          bsLib.railsHost() +
            "/marketing_api/check_email_validation?email=" +
            encodeURIComponent(that.value) +
            workEmailParam,
          {},
          true,
          {
            "X-CSRF-Token": csrf_token,
            "content-type": "application/x-www-form-urlencoded; charset=utf-8", // Setting content type.
          },
          function (data) {
            var dataRequest = bsLib.JSONParse(data.response);

            //remove disable
            if (submitBtn) {
              submitBtn.removeAttribute("disabled");
              submitBtn.value = submitBtn.dataset.valueText;
            }

            if (dataRequest.valid === false) {
              that.dataset.notvalid = "1";

              that.classList.add("error-border");
              if (
                that.parentNode.getElementsByClassName("error-message")
                  .length === 0
              ) {
                that.insertAdjacentHTML(
                  "afterend",
                  '<span class="error-message" id= "email-error' +
                    emailUniqueID +
                    '">' +
                    emailErrorMsg +
                    "</span>"
                );
              }
            }
          },
          function () {}
        );
      }
    }
  });

  contactFormEleMulti.messageField.addEventListener("blur", function (event) {
    intereactedWithFormField(contactFormEleMulti, {
      field: "message",
      action: "click",
    });
  });

  contactFormEleMulti.companyField.addEventListener("blur", function (event) {
    intereactedWithFormField(contactFormEleMulti, {
      field: "company",
      action: "click",
    });
  });

  //Submit Contact Form
  contactFormEleMulti.formObj.addEventListener("submit", function (e) {
    e.preventDefault();

    //submit Interaction
    intereactedWithFormField(contactFormEleMulti, {
      field: "submit",
      action: "click",
    });

    CSFMultiFormScope.setScope(this);

    if (!CSFMultiFormScope.validateFields()) {
      return false;
    }

    return false;
  });
}